import SmoothScroll from 'smooth-scroll';

const smoothScroll = new SmoothScroll();
const topNavElement: HTMLElement | null = document.querySelector('.top-nav');

export const smoothScrollTo = (target: HTMLElement | number): void => {
    let offset: number = 0;

    if (topNavElement !== null) {
       offset = topNavElement.clientHeight;
    }

    if (typeof target === 'number') {
        target -= offset;
    }

    smoothScroll.animateScroll(target, null, {
        speed: 1000,
        offset: offset,
    });
};